import { request } from "./httpClient";


function getUrl(prefixKey) {
    const prefix = (window.appConfig && window.appConfig[prefixKey]);
    return process.env.REACT_APP_API_URL + prefix;
}

export async function fetchMetricsBySiteId({ queryKey }) {
  const [, siteId, startTime, endTime, initialOffset = 0, limit = 100, timeout] = queryKey;
  const url = `${getUrl("metricsPrefix")}metrics_by_site_id/${siteId}`;

  let allData = [];
  let offset = initialOffset;

  try {
    while (true) {
      const params = {
        start_time: startTime,
        end_time: endTime,
        offset,
        limit,
      };
      const pageData = await request(url, { params }, timeout);
      if (!Array.isArray(pageData) || pageData.length === 0) break;

      allData.push(...pageData);
      if (pageData.length < limit) break;

      offset += pageData.length;
    }

    return allData;
  } catch (error) {
    console.error("Error fetching metrics:", error.message);
    return null;
  }
}